// Copyright (c) 2021 Proto Labs, Inc. All Rights Reserved.

import { TokenManagerConfig } from '@protolabs/enterprise-token-manager';

const TokenManagerConfig: TokenManagerConfig = {
	clientId: window.clientId || 'document-upload-spa-amer-client',
	authority: window.authority || 'https://identity.global.sit.protolabs.io',
	redirectUri: window.redirectUri || 'http://localhost:6846/oidc-signin-callback',
	monitorOnRedirectUri: false,
	postLogoutRedirectUri:
		window.postLogoutRedirectUri || 'http://localhost:6846/oidc-signout-callback',
};

export default TokenManagerConfig;
